<template>
  <div class="bb-kpi-table">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <h2 class="bb-page-title">KPI</h2>
    <div class="bb-kpi-table-header">
      <div class="bb-tabs">
        <div
          class="bb-tabs__item"
          v-for="department in departmentsList"
          :key="department.id"
          @click="changeTab(department)"
          :class="{ 'bb-tabs__item_active': activeTab === department.id }">
          <span class="bb-tabs__title">{{ department.name }}</span>
        </div>
      </div>
      <div class="bb-kpi-table-header-info">
        <div class="bb-kpi-table-header-info__date">
          <i class="icon-calendar bb-kpi-table-header-info__icon" />
          {{ currentDate }}
        </div>
        <button class="bb-kpi-table-header-info__report bb-button" @click.stop="openReports">
          report
        </button>
       <div class="bb-kpi-table-header-info__export">
         <div class="bb-popup-export-excel bb-popup-export-excel_kpi">
           <i class="icon-menu bb-popup-export-excel__icon" @click.stop="popupExport = true"/>
           <transition name="bounce">
             <div class="bb-popup-export-excel-popup"
                  @click.stop="openExport()"
                  v-if="popupExport"
                  v-click-outside="hidePopupExport">
               <span class="bb-popup-export-excel-popup__text">Export to Excel</span>
             </div>
           </transition>
         </div>
       </div>
      </div>
    </div>
    <div>
      <BBTable
        :columns="kpiColumnsData"
        :rows="kpiRowsData"
      />
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="openEarned = false,
                           activeColumn = ''
                           openBalanceWarn = false"
                   v-if="openEarned"
                   :table-mode="!openBalanceWarn"
                   :title="titleModal">
        <template v-if="openBalanceWarn">
          <div class="bb-kpi-table-modal bb-kpi-table-modal_balance">
            <h3 class="bb-kpi-table-modal__title">
              Need to open a balance for funds
            </h3>
            <input class="bb-input bb-input_border"
                   v-model="startOpenBalance"
                   @keyup.enter="openBalanceFund()"/>
            <button class="bb-button bb-kpi-table-modal__btn" @click="openBalanceFund()">SAVE</button>
          </div>
        </template>
        <template v-else>
          <div class="bb-kpi-table-modal">
            <BBTable :columns="kpiEarnedColumnsData"
                     @sort="setSort"
                     @setRejectTable="setRejectTable"
                     :rows="kpiEarnedRowsData"
            />
          </div>
        </template>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="openRejectProforma"
                   :table-mode="false"
                   :without-padding="true"
                   :center-title="true"
                   @close="openRejectProforma = false,
                           openEarned = true"
                   :title="rejectTitle"
      >
        <RejectServiceKPI @close="openRejectProforma = false,
                                  openEarned = true"
                          :project="serviceProject"
                          @reject="setReject"
        />
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="openModal=false" v-if="openModal">
        <h3 class="bb-kpi-table-modal__title">{{modalTitle}}</h3>
        <TransferKPI @setTransfer="createTransfer" :from-user="transferFrom" :list="kpiEarnedRowsData">
          <button class="bb-button bb-kpi-table-modal__btn">save</button>
        </TransferKPI>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="closeProforma" v-if="proformaOpen">
        <ProformaInvoice @close="proformaOpen = false"
                         :view-mode="true"
                         :editable-invoice="editableInvoice"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ExportExcel :columns="kpiColumnsData"
                   v-if="openSettingExport"
                   :withoutColumns="true"
                   :data="dataForExport"
                   file-name="kpi"
                   :generateExcel="generateExcel"
                   @close="hideSettingExport"/>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="displayReports=false" v-if="displayReports">
        <KpiReports :department="activeTab"/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import KpiApi from '@/api/Kpi/api'
import InvoicesApi from '@/api/Invoce/api'
import UsersListApi from '@/api/UsersList/api'
import DepartmentsApi from '@/api/DepartmentsList/api'
import RejectServiceKPI from '@/components/Finance/KPI/RejectServiceKPI/RejectServiceKPI'
import BBTable from '@/components/Main/BBTable/BBTable'
import Table from '@/components/Main/Table/Table'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import kpiTableColumns from '@/constants/TablesOptions/kpiTable'
import kpiEarnedTableColumns from '@/constants/TablesOptions/kpiEarnedTable'
import kpiForApprovalColumns from '@/constants/TablesOptions/kpiForApproval'
import kpiPotentialColumns from '@/constants/TablesOptions/kpiPotentialTable'
import moment from 'moment'
import _ from 'lodash'
import departmentsTypes from '@/constants/departmentsTypes'
import validateNum from '@/mixin/validateNum'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import TransferKPI from '@/components/Finance/KPI/TrasferKPI/TransferKPI'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import SettingsKPI from '@/components/Settings/PositionsList/Positions/SettingsKPI/SettingsKPI'
import ExportExcel from '@/components/Main/ExportExcel/ExportExcel'
import KpiReports from '@/components/Finance/KPI/KpiReports/KpiReports'
import setKpiServices from '@/mixin/setKpiServices'
import approvedPosition from '@/constants/approvedPosition'

export default {
  name: 'FinanceKPI',
  mixins: [validateNum, setKpiServices],
  components: {
    KpiReports,
    ProformaInvoice,
    TransferKPI,
    Table,
    BBTable,
    RejectServiceKPI,
    ModalWindow,
    LoaderFly,
    SettingsKPI,
    ExportExcel
  },
  data () {
    return {
      reportList: [],
      displayReports: false,
      popupExport: false,
      openSettingExport: false,
      dataForExport: {},
      openKpiSettings: {
        left: 0,
        top: 0,
        item: false,
        department: ''
      },
      editableInvoice: {
        invoice: {}
      },
      proformaOpen: false,
      loaderRun: false,
      openRejectProforma: false,
      serviceProject: {},
      startOpenBalance: '',
      openBalanceWarn: false,
      openBalance: false,
      kpiPotentialRowsData: [],
      departmentsTypes: departmentsTypes,
      titleModal: '',
      rejectTitle: 'Reason for rejection',
      optionsKpiTable: kpiTableColumns,
      optionsEarnedTable: kpiEarnedTableColumns,
      openEarned: false,
      sort: '',
      activeTab: 1,
      modalTitle: '',
      activeColumn: '',
      openModal: false,
      transferFrom: false,
      activeTypeUser: false
    }
  },
  computed: {
    currentDate () {
      return moment().format('MMM, YYYY')
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    departmentsList: {
      get: function () {
        return this.$store.getters.positionsList
      },
      set: function (data) {
        this.$store.dispatch('setPositionsList', data)
      }
    },
    kpiColumnsData: {
      get: function () {
        return this.$store.getters.kpiColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setKpiColumnsData', data)
      }
    },
    kpiRowsData: {
      get: function () {
        return this.$store.getters.kpiRowsData
      },
      set: function (data) {
        this.$store.dispatch('setKpiRowsData', data)
      }
    },
    kpiEarnedColumnsData: {
      get: function () {
        return this.$store.getters.kpiEarnedColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setKpiEarnedColumnsData', data)
      }
    },
    kpiEarnedRowsData: {
      get: function () {
        return this.$store.getters.kpiEarnedRowsData
      },
      set: function (data) {
        this.$store.dispatch('setKpiEarnedRowsData', data)
      }
    }
  },
  methods: {
    openReports () {
      this.displayReports = true
    },
    async generateExcel (data) {
      const resp = await InvoicesApi.getKpiExcel(data, this.activeTab)
      return resp
    },
    openExport () {
      this.openSettingExport = true
      this.dataForExport = {
        query: this.fullFilter
      }
    },
    hideSettingExport () {
      this.hidePopupExport()
      this.openSettingExport = false
    },
    setRejectTable ({row}) {
      this.openRejectProforma = true
      this.serviceProject = row
      this.openEarned = false
    },
    hidePopupExport () {
      this.popupExport = false
    },
    createTransfer (transfer) {
      InvoicesApi.setTransfer(transfer)
        .then((resp) => {
          this.getKpiUsers(this.activeTab)
          this.openModal = false
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.openBalance = false
          } else {
            console.error(err)
          }
        })
    },
    async getListForTransfer (item) {
      const type = _.get(item, 'position.department', 2)
      const query = {
        column: 'earned',
        userID: item._id,
        userType: type === 1 ? 'businessConsultant' : 'projectManager',
        userTypeID: type
      }
      await this.getServicesByManager(query)
      this.modalTitle = 'Transfer'
      this.openModal = true
      this.transferFrom = item
    },
    addActions () {
      this.kpiColumnsData.forEach(item => {
        if (item.actionType === 'openTransfer') {
          item.action = this.getListForTransfer
        }
        if (item.actionType === 'openKpiEarnedTable') {
          item.action = this.openInfoTable
        }
        if (item.hover) {
          item.clickAction = this.openInfoTable
        }
        if (item.openModal) {
          item.openModal.display = this.openInfoPosition
          item.openModal.hide = this.hideInfoPosition
        }
      })
    },
    addActionsInfo () {
      this.kpiEarnedColumnsData.forEach(item => {
        if (item.actions) {
          item.actions.save = this.setApprove
        }
        if (item.actionType === 'setApprove') {
          item.action = this.setApprove
        }
        if (item.actionType === 'openProforma') {
          item.action = this.openProforma
        }
        if (item.hover && item.property === 'invoice.number') {
          item.clickAction = this.openProforma
        }
      })
    },
    getUserPosition (type, extra) {
      const businessConsultantExtra = approvedPosition.BUSINESS_CONSULTANT_EXTRA_VALUE
      const businessConsultant = approvedPosition.BUSINESS_CONSULTANT_VALUE
      const businessConsultantKey = extra ? businessConsultantExtra : businessConsultant
      const projectManagerExtra = approvedPosition.PROJECT_MANAGER_EXTRA_VALUE
      const projectManager = approvedPosition.PROJECT_MANAGER_VALUE
      const projectManagerKey = extra ? projectManagerExtra : projectManager
      return type === 1 ? businessConsultantKey : projectManagerKey
    },
    setApprove (row) {
      this.loaderRun = true
      if (!this.openBalance) {
        this.openBalanceWarn = true
        return
      }
      const {
        project = {},
        factValue,
        assignedValue,
        _id: userKpiId,
        invoice: { id: invoiceId },
        serviceCategoryType,
        user: userId,
        managerComment = '',
        service: { _id: serviceId },
        isDouble = false,
        doubleId = undefined,
        approvedDate: rowApprovedDate
      } = row
      const { dateEnd = new Date() } = project
      row.factValue = this.validateNum(factValue)
      if (!row.factValue || row.factValue > assignedValue) {
        this.$set(row, 'factError', `must be 1 - ${assignedValue}, AED`)
        return
      }
      const approve = {
        userKpiId,
        invoiceId,
        serviceCategoryType,
        userId,
        managerComment,
        serviceId,
        value: row.factValue,
        isDouble,
        doubleId,
        approvedDate: rowApprovedDate || dateEnd
      }
      if (!approve.value) return
      if (row.$doubleKpi) approve.bonusKpi = true
      InvoicesApi.setApprove(approve)
        .then(resp => {
          const approveKpiIndex = this.kpiEarnedRowsData.findIndex(({_id}) => _id === row._id)
          if (approveKpiIndex !== -1) {
            this.kpiEarnedRowsData.splice(approveKpiIndex, 1)
            if (!this.kpiEarnedRowsData.length) {
              this.openEarned = false
            }
          }
          this.getKpiUsers(this.activeTab)
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    },
    setReject (reasons) {
      this.loaderRun = true
      const reasonsText = reasons.map(item => item.text)
      const reject = {
        userKpiId: this.serviceProject._id,
        rejectedComments: reasonsText,
        rejectedDate: new Date()
      }
      InvoicesApi.setReject(reject)
        .then(resp => {
          this.loaderRun = false
          this.openRejectProforma = false
          this.openEarned = false
          this.getKpiUsers(this.activeTab)
        })
        .catch(err => {
          console.error(err)
        })
    },
    validateNum (number) {
      if (typeof number === 'string') {
        number = number.replace(/[^.\d;]/g, '')
      }
      if (isNaN(number)) {
        return 0
      } else {
        return +number
      }
    },
    setSort (value, column) {
      this.sort = value
      const [kpi] = this.kpiEarnedRowsData
      const type = kpi.position ? kpi.position.department : false
      const query = {
        column: column.mark,
        userID: kpi.user,
        userTypeID: type,
        sort: this.sort
      }
      this.getServicesByManager(query)
    },
    changeTab (department) {
      this.activeTab = department.type
      this.getApprove()
      this.getKpiUsers(this.activeTab)
    },
    closeProforma () {
      this.proformaOpen = false
    },
    openProforma (row) {
      const id = _.get(row, 'invoice.id', false)
      if (!id) return
      this.loaderRun = true
      InvoicesApi.getInvoiceById(id)
        .then(resp => {
          this.editableInvoice = {
            invoice: resp.data
          }
          this.proformaOpen = true
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    },
    openInfoPosition (row, column, e) {
      const positionName = _.get(row, 'position.name', '')
      this.openKpiSettings = {
        left: e.clientX + 'px',
        top: e.clientY + 12 + 'px',
        item: row.position,
        department: positionName
      }
    },
    hideInfoPosition (row, column) {
      this.openKpiSettings = {
        left: 0,
        top: 0,
        item: false,
        department: ''
      }
    },
    async openInfoTable (kpi, column) {
      const columnValue = _.get(kpi, column.prop, 0)
      if (!columnValue) return
      const type = kpi.position ? kpi.position.department : false
      const query = {
        column: column.mark,
        userID: kpi._id,
        userTypeID: type,
        sort: this.sort
      }
      await this.getServicesByManager(query)
      this.activeColumn = column.mark
      if (this.activeColumn === 'potential') {
        this.kpiEarnedColumnsData = kpiPotentialColumns
      } else if (this.activeColumn === 'earned') {
        this.kpiEarnedColumnsData = kpiEarnedTableColumns
      } else {
        this.kpiEarnedColumnsData = kpiForApprovalColumns
      }
      this.titleModal = _.capitalize(column.title)
      this.addActionsInfo()
      this.openEarned = true
    },
    getOpenBalance () {
      KpiApi.getBalance()
        .then((resp) => {
          this.openBalance = !!resp.data.status
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.openBalance = false
          } else {
            console.error(err)
          }
        })
    },
    getKpiUsers (department) {
      KpiApi.getUsersKPI(department)
        .then((resp) => {
          this.kpiRowsData = resp.data
        })
        .catch((err) => {
          console.error(err)
        })
    },
    openBalanceFund () {
      const number = this.validateNum(this.startOpenBalance)
      KpiApi.openBalance(number)
        .then((resp) => {
          this.openBalance = resp.data.status
          this.openBalanceWarn = false
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getDepartments () {
      this.loaderRun = true
      DepartmentsApi.getDepartments()
        .then(resp => {
          this.departmentsList = resp.data.departments
          this.activeTab =
              this.departmentsList && this.departmentsList[0]
                ? this.departmentsList[0].id
                : false
          this.loaderRun = false
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
        })
    },
    setRowsData (type) {
      this.kpiRowsData.forEach(item => {
        const potential = _.get(item, 'potential', 0)
        const earned = _.get(item, 'earned', 0)
        const clickStop = []
        if (!potential) {
          clickStop.push('potential')
        }
        if (!earned) {
          clickStop.push('earned')
        }
        item.clickStop = clickStop
      })
    },
    getUserKPI () {
      this.loaderRun = true
    },
    getUserList () {
      this.loaderRun = true
      UsersListApi.getUsersList({limit: 1000, assigned: true})
        .then(resp => {
          this.loaderRun = false
          this.users = _.filter(resp.data.users, item => item)
          this.setRowsData(this.activeTab)
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
        })
    },
    roundNum (num) {
      return Math.round(num * 100) / 100
    },
    serviceAmount ({serviceValue, serviceQuantity = 1, serviceDiscount = 0}) {
      const value = serviceValue * serviceQuantity
      const discount = (serviceDiscount * value) / 100
      return value - discount
    },
    setColorServiceName (serviceName, paymentDate) {
      const diff = moment().diff(paymentDate, 'month')
      const red = diff >= 3
      const yellow = diff >= 2 && diff < 3
      let status
      if (red) {
        status = 'red'
      } else if (yellow) {
        status = 'yellow'
      }
      return `<span class="bb-table-kpi-services bb-table-kpi-services_${status}">${serviceName}</span>`
    },
    async getServicesByManager (query) {
      this.loaderRun = true
      this.getOpenBalance()
      const resp = await KpiApi.getKPIByUser(query)
      if (resp.status !== 200) console.error(resp)
      this.kpiEarnedRowsData = resp.data.map(item => {
        item['factKPI.approvalValue'] = _.get(item, ['factKPI', 'approvalValue'], 0)
        const serviceName = _.get(item, ['service', 'name'], '')
        if (query.column !== 'earned') {
          _.set(item, ['service', 'name'], this.setColorServiceName(serviceName, item.paymentDate))
        }
        if ((item.currentValue - item.approvedValue) <= 0 && (query.column === 'potential')) {
          item.static = true
        }
        return item
      })
      this.loaderRun = false
    },
    getApprove () {
      this.kpiColumnsData = this.activeTab === 3 ? kpiTableColumns.filter(item => !item.forProject) : kpiTableColumns
    }
  },
  watch: {
    activeTab (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.addActions()
      this.setRowsData(newVal)
    }
  },
  beforeMount () {
    this.kpiEarnedColumnsData = kpiEarnedTableColumns
    this.kpiColumnsData = kpiTableColumns
    this.addActions()
    this.getApprove()
    this.departmentsList = this.departmentsTypes
    this.getUserList()
    this.getKpiUsers()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-kpi-table {
    @include global-font;

    &__preview-position {
      position: fixed;
      background-color: $color-white;
      padding: 21px;
      border-radius: 8px;
      box-shadow: 0 0 15px rgba($color-black, 0.1);
      z-index: 99;
    }

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      position: relative;
      z-index: 4;

      &-info {
        display: flex;
        align-items: center;
        height: 42px;

        &__date {
          background-color: $color-white;
          margin-right: 14px;
          padding: 12px;
          border-radius: 5px;
          color: $color-accent;
          font-weight: 600;
          font-size: 15px;
          line-height: 18px;
        }

        &__icon {
          font-size: 17px;
        }

        &__report {
          width: 90px;
          text-transform: uppercase;
          font-size: 13px;
          line-height: 16px;
        }

        &__export {
          position: relative;
          height: 42px;
          width: 42px;
          margin-left: 3px
        }
      }
    }

    &-modal {
      width: 70vw;
      min-width: 1200px;
      min-height: calc(100%);
      margin-right: 4px;

      &_balance {
        width: auto;
        min-width: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      &__title {
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 19px;
      }

      &__btn {
        text-transform: uppercase;
        width: 117px;
        margin: 20px auto auto;
      }
    }

    &-service {
      background-color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Finance/KPI/KPI.vue